export default function () {
  return [
    {
      title: 'Strona główna',
      to: '/kokpit',
      htmlBefore: '<i class="material-icons">home</i>',
      htmlAfter: ''
    },
    {
      title: 'Użytkownicy',
      to: '/uzytkownicy',
      htmlBefore: '<i class="material-icons">people</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Klienci',
      to: '/klienci',
      htmlBefore: '<i class="material-icons">account_circle</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Cenniki wzorcowe',
      to: '/cenniki',
      htmlBefore: '<i class="material-icons">list_alt</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Dostawcy',
      to: '/dostawcy',
      htmlBefore: '<i class="material-icons">local_shipping</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Produkty',
      to: '/produkty',
      htmlBefore: '<i class="material-icons">add_business</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Kategorie produktów',
      to: '/kategorie',
      htmlBefore: '<i class="material-icons">dashboard_customize</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Grupy produktowe',
      to: '/grupy-produktowe',
      htmlBefore: '<i class="material-icons">workspaces</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Zamówienia',
      to: '/zamowienia',
      htmlBefore: '<i class="material-icons">add_shopping_cart</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Wewnętrzne',
      to: '/zamowienia-wewnetrzne',
      htmlBefore: '<i class="material-icons">shopping_cart</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Historia wpłat',
      to: '/wplaty',
      htmlBefore: '<i class="material-icons">history</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Rozliczenia',
      to: '/rozliczenia',
      htmlBefore: '<i class="material-icons">euro_symbol</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Szablony tras',
      to: '/szablony-tras',
      htmlBefore: '<i class="material-icons">route</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Urlopy',
      to: '/urlopy',
      htmlBefore: '<i class="material-icons">date_range</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Raport odpadu',
      to: '/raport-odpadu',
      htmlBefore: '<i class="material-icons">recycling</i>',
      htmlAfter: '',
      permissions: 'is-admin'
    },
    {
      title: 'Wyloguj się',
      htmlBefore: '<i class="material-icons">power_settings_new</i>',
      htmlAfter: '',
      to: '/wyloguj'
    }
  ];
}
